import type { GridColumn } from '../../components/tables/EditableGrid';
import {
  addCustomPriority,
  conditions,
  priorities,
  sampleStatuses,
  sampleTypes,
} from '../../constants/statusOptions';

export const sampleColumns: GridColumn[] = [
  {
    // FEAT-2026-0018: show which borehole / test pit each sample is from.
    // Read-only — the location is a property of the selected location, not an
    // editable per-sample field. Populated from the selected Location.LocationId
    // by the hosting page (LocationsTabContent / LocationsPage).
    field: 'LocationId',
    headerName: 'Location ID',
    type: 'text',
    readonly: true,
    width: 120,
  },
  {
    field: 'SampleId',
    headerName: 'Sample Reference',
    type: 'text',
    required: true,
    width: 120,
  },
  {
    field: 'DepthTop',
    headerName: 'Depth Top (m)',
    type: 'number',
    required: true,
    width: 110,
  },
  {
    field: 'DepthBase',
    headerName: 'Depth Base (m)',
    type: 'number',
    width: 110,
  },
  {
    field: 'SampleType',
    headerName: 'Type',
    type: 'select',
    required: true,
    options: sampleTypes,
    width: 100,
  },
  {
    field: 'Status',
    headerName: 'Sample Status',
    type: 'select',
    options: sampleStatuses,
    width: 130,
  },
  {
    field: 'Priority',
    headerName: 'Sample Priority',
    type: 'select',
    options: priorities,
    allowCustomOption: true,
    onCustomOptionAdded: (val) => addCustomPriority(val),
    width: 120,
  },
  {
    field: 'Condition',
    headerName: 'Condition',
    type: 'select',
    options: conditions,
    width: 110,
  },
  {
    field: 'SampleComments',
    headerName: 'Comments',
    type: 'text',
    flex: 1,
  },
  {
    field: 'BoxOrBucketNumber',
    headerName: 'Shipment Box/Bucket',
    type: 'text',
    width: 130,
  },
  {
    field: 'StorageLocation',
    headerName: 'Storage Location',
    type: 'text',
    width: 130,
  },
];
